import _ from 'lodash';
import Immutable from 'immutable';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';
import MemberStore from './MemberStore.js';
import { EventEmitter } from 'events';
import assign from 'object-assign';

const ActionTypes = Constants.ActionTypes;
const CHANGE_GALLERY_EVENT = 'changeGallery';

const Image = Immutable.Record({ // Immutable objekts
  index: undefined, // kārtas nr
  created: undefined,
  file_id: undefined, // faila ID vērtība
  file: undefined, // filename
  likes: 0, // bilžu like skaits
  is_liked: false, // vai lietotājam patīk bilde
  is_compliment: false, // vai ir izteicis komplimentu
  reported_by_member: false, // vai lietotājs ziņojis par bildi
  self: false, // vai sava bilde
  load_status: undefined, // bildes ielādes status 'ok'/'error'
  gcloud: false, // pazīme, ka bilde augšupielādēta Google Cloud
  uncensored: false, // vai necenzēta
  profile: false // vai profila bilde
});

let _memberImages = {};
let _images = null; // Immutable objekti ar bilžu datiem
let _localImages = null; // Immutable objekti ar bilžu datiem
let _isEmpty = null; // galerijā nav bilžu, uzseto pie json ielādes un ja json ir tukšs
let _load = null; // vai tiek ielādēti galerijas dati
let _current = null; // atvērtās bildes _images indekss
let _complimentSending = null; // vai tiek sūtīts kompliments uz serveri
let _memberId = null; // lietotāja id

const GalleryStore = assign({}, EventEmitter.prototype, {

  emitChange() {
    this.emit(CHANGE_GALLERY_EVENT);
  },

  /**
	* @param {function} callback
	*/
  addChangeListener(callback) {
    this.on(CHANGE_GALLERY_EVENT, callback);
  },

  /**
	* @param {function} callback
	*/
  removeChangeListener(callback) {
    this.removeListener(CHANGE_GALLERY_EVENT, callback);
  },

  clearImages() {
    if (_images) {
      _images = _images.clear();
    }
  },

  clearLocalImages() {
    // bildes, kas tiek ielādētas bez pieprasījuma uz serveri
    if (_localImages) {
      _localImages = _localImages.clear();
    }
  },

  /**
	* Iestata sākotnējās vērtības
	*/
  setInitData() {
    // ja _images, jau ir uzsetots, tad izpilda clear()
    if (_images) {
      _images = _images.clear();
    } else {
      _images = Immutable.List(); // Immutable objekti ar bilžu datiem
    }

    if (!_localImages) {
      _localImages = Immutable.List(); // Immutable objekti ar bilžu datiem
    }

    _isEmpty = false; // galerijā nav bilžu, uzseto pie json ielādes un ja json ir tukšs
    _load = true; // vai tiek ielādēti galerijas dati
    _current = null; // atvērtās bildes _images indekss
    _complimentSending = false; // vai tiek sūtīts kompliments uz serveri
    _memberId = null;
  },

  /**
	* @param {boolean} Vai tukša galerija
	*/
  setEmpty(status) {
    _isEmpty = status;
  },

  /**
	* @param {string} Lietotāja id
	*/
  setMemberId(memberId) {
    _memberId = memberId;
  },

  /**
	* @param {string} id bildes id
	*/
  addLocalImage(id, file_key, gcloud = false, uncensored = false) {
    let exists = false;
    _localImages.map((item) => {
      if (item.get('file') == id) {
        exists = true;
      }
    });
    if (exists) {
      return;
    }
    let reported_by_member = false;
    if (id.match(/\.(jpeg|jpg|gif|png)$/) != null && !gcloud) {
      reported_by_member = true;
    }
    _localImages = _localImages.push(new Image({
      index: _localImages.size,
      likes: 0,
      is_liked: false,
      reported_by_member,
      self: false,
      is_compliment: false,
      file: id, // faila ID vērtība
      file_id: id, // faila ID vērtība
      gcloud,
      uncensored,
    }));
    // uzstāda aktīvo bildi
    _current = _localImages.size;
  },

  /**
	* @param {array} Galerijas bildes
	* @param {string} Kuru bildi atvērt kā pirmo (file)
	* @param {string} Lietotāja ID, kura bildes tās ir
	*/
  setImages(images, gotoImage, memberId) {
    if (_isEmpty) {
      return false;
    }

    this.clearImages();

    let i = 0;
    // Atkīvā bilde
    _current = 0;

    // pievieno bildes datus
    images.forEach((image) => {
      _images = _images.push(new Image({
        index: i,
        created: image.created,
        file_id: image.file_id, // faila ID vērtība
        file: image.file, // filename
        likes: image.likes, // bilžu like skaits
        is_liked: image.is_liked, // vai lietotājam patīk bilde
        is_compliment: image.is_compliment, // vai ir izteicis komplimentu
        reported_by_member: image.reported_by_member, // vai lietotājs ziņojis par bildi
        self: image.self, // vai sava bilde 0/1
        gcloud: image.gcloud,
        uncensored: image.uncensored,
        profile: image.profile
      }));
      // uzstāda aktīvo bildi
      if (gotoImage && gotoImage == image.file) {
        _current = i;
      }
      i++;
    }, this);

    if (memberId) {
      this.setMemberImages(memberId, _images);
    }
  },

  setMemberImages(memberId, images) {
    _memberImages[memberId] = images;
  },

  /**
	* @param {boolean} Vai bilžu dati ielādēti
	*/
  setLoad(loadStatus) {
    _load = loadStatus;
  },

  /**
	* @param {number} Aktīvās bildes indekss
	*/
  setCurrent(index) {
    _current = index;
  },

  setCurrentByFilename(filename) {
    _current = _images.findIndex((item) => item.get('file') === filename);
  },

  /**
	* Kā aktīvo norāda nākošo bildi
	*/
  setNext() {
    // nav pievienotas bildes vai ir tikai viena bilde
    if (_isEmpty || this.getTotal() == 1) {
      return false;
    }

    _current = this.getNewIndex('next');

    return true;
  },

  /**
	* Kā aktīvo norāda iepriekšējo bildi
	*/
  setPrev() {
    // nav pievienotas bildes vai ir tikai viena bilde
    if (_isEmpty || this.getTotal() == 1) {
      return false;
    }

    _current = this.getNewIndex('prev');

    return true;
  },

  /**
	* Bildei uzliek ielādes statusu, ok - bilde ielādēta, error - neizdevās ielādēt
	* @param {number} Aktīvās bildes index
	* @param {string} Ielādes status - ok || error
	*/
  setLoadStatus(index, status) {
    _images = _images.update(index, (image) => {
      if (typeof image !== 'undefined') {
        return image.set('load_status', status);
      }
    });
  },

  /**
	* Bildei jauns Man patīk
	* @param {number} Aktīvās bildes index
	* @param {number} "Man patīk" skaits
	*/
  setLikes(index, count) {
    const image = _images.get(index);

    // skaits sakrīt, neatjaunojam datus
    if (image.likes == count) {
      return false;
    }

    _images = _images.update(index, imageItem => imageItem.withMutations((image) => {
      image.set('likes', count).set('is_liked', 1);
    }));
  },

  /**
	* Bildei pievienots kompliments
	* @param {number} Aktīvās bildes index
	*/
  setCompliment(index) {
    const image = _images.get(index);

    _images = _images.update(index, image => image.set('is_compliment', true));
  },

  /**
	* Uzstāda pazīmi, ka ir ziņots par bildi
	* @param {number} Bildes index
	*/
  setReport(index) {
    const image = _images.get(index);

    _images = _images.update(index, image => image.set('reported_by_member', true));
  },

  /**
	* Compliment Sending statuss
	* @param {boolean} true - notiek sūtīšana, datu saņemšana
	*/
  setComplimentSending(status) {
    _complimentSending = status;
  },

  setUncensoredByFilename(filename, uncensored) {
    const index = _images.findIndex((item) => item.get('file') === filename);
    _images = _images.update(index, (image) => {
      if (typeof image !== 'undefined') {
        return image.set('uncensored', uncensored);
      }
    });
  },

  setLocalUncensoredByFilename(filename, uncensored) {
    const index = _localImages.findIndex((item) => item.get('file') === filename);
    _localImages = _localImages.update(index, (image) => {
      if (typeof image !== 'undefined') {
        return image.set('uncensored', uncensored);
      }
    });
  },

  /**
	* @return {array} Galerijas bildes
	*/
  getImages() {
    return _images;
  },

  getMemberImages(memberId) {
    return _memberImages[memberId] || null;
  },

  /**
	* @return {array} Lokālās galerijas bildes
	*/
  getLocalImages() {
    return _localImages;
  },

  /**
	* @return {string} Lietotāja id
	*/
  getMemberId() {
    return _memberId;
  },

  /**
	* @return {boolean} Vai tiek ielādēti galerijas dati
	*/
  getLoad() {
    return _load;
  },

  /**
	* @return {object} Aktīvās bildes objekts
	*/
  getCurrent() {
    if (_load) { // vēl tiek lādēti dati
      return null;
    }
    return _images.get(_current);
  },

  /**
	* @return {number} Aktīvās bildes indekss
	*/
  getCurrentIndex() {
    return _current;
  },

  /**
	* @return {object} Nākošās bildes objekts
	*/
  getNextImage() {
    // ja vēl lādē datus vai arī galerija tukša|viena bilde, tad atgriež null
    if (_load || this.getTotal() < 2) {
      return null;
    }

    // iegūst indekss vērtību
    const nextIndex = this.getNewIndex('next');

    return _images.get(nextIndex);
  },

  /**
	* @return {object} Nākošās bildes objekts
	*/
  getPrevImage() {
    // ja vēl lādē datus vai arī galerija tukša|viena bilde, tad atgriež null
    if (_load || this.getTotal() < 2) {
      return null;
    }

    // iegūst indekss vērtību
    const prevIndex = this.getNewIndex('prev');

    return _images.get(prevIndex);
  },

  /**
	* @return {number} Bilžu skaits
	*/
  getTotal() {
    return _images.size;
  },

  /**
	* @return {number} Lokālo bilžu skaits
	*/
  getLocalTotal() {
    return _localImages.size;
  },

  /**
	* Vai tiek sūtīts/pievienots jauns kompliments
	* @return {boolean}
	*/
  getComplimentSending() {
    return _complimentSending;
  },

  /**
	* Iegūst jauno indekss vērtību, izmanto priekš bilžu pārslēgšanās
	* @param {string} next vai prev
	*
	* @return {string} Jaunais indekss
	*/
  getNewIndex(navigation) {
    const total = this.getTotal();
    let key = _current;

    // attiecīgi, ja next, tad key++, pretēji --
    if (navigation == 'next') {
      key++;
    } else {
      key--;
    }

    // pārbauda vai neiziet ārpus robežām
    if (key < 0) {
      key = total - 1;
    }

    if (key >= total) {
      key = 0;
    }

    // atgrriež jauno index
    return key;
  },

  getLocalUncensoredByFilename(filename) {
    const index = _localImages.findIndex((item) => item.get('file') === filename);
    if (index < 0) {
      return null;
    }

    const image = _localImages.get(index);
    if (typeof image === 'undefined') {
      return null;
    }

    return image.get('uncensored');
  },

  /**
	* Izdzēš visus datus
	*/
  deleteAllData() {
    this.setInitData();
  },

  /**
	* @return {boolean} Vai galerija tukša?
	*/
  isEmpty() {
    return _isEmpty;
  },
});

// default vērtības iestata
GalleryStore.setInitData();

GalleryStore.dispatchToken = AppDispatcher.register((action) => {
  switch (action.type) {
    case ActionTypes.GALLERY_LOAD_SUCCESS:
      AppDispatcher.waitFor([MemberStore.dispatchToken]);
      // ja dati jau ielādēti, tad vēlreiz nevajag pievienot
      if (!GalleryStore.getLoad()) {
        break;
      }

      GalleryStore.setLoad(false); // dati ielādēti
      var count = GalleryStore.getTotal();
      if (count <= 0) {
        count = action.images.size || action.images.length;
      }
      // ir bildes
      if (count > 0) {
        GalleryStore.setEmpty(false);
        GalleryStore.setImages(action.images, action.gotoImage, action.memberId);
        GalleryStore.setMemberId(action.memberId);
      }
      // nav bildes
      else {
        GalleryStore.setEmpty(true);
      }
      // GalleryStore.setCurrent();
      GalleryStore.emitChange();
      break;

    case ActionTypes.GALLERY_LOAD_FAIL:
        GalleryStore.setLoad(false);
        GalleryStore.setEmpty(true);
        GalleryStore.setMemberId(null);
        GalleryStore.emitChange();
        break;

    case ActionTypes.GALLERY_LOAD_NAVIGATION:

      // tukša galerija, daram neko
      if (GalleryStore.isEmpty()) {
        break;
      }

      // nākošā bilde
      if (
        (action.next && GalleryStore.setNext())
				||
				(action.prev && GalleryStore.setPrev())
      ) {
        GalleryStore.emitChange();
        break;
      }

      // doties uz konkrēto bildi
      if (action.goTo) {
        GalleryStore.setCurrent(action.index);
        GalleryStore.emitChange();
      }

      break;

    case ActionTypes.GALLERY_LOAD_STATUS:

      // pievieno bildes statusu
      GalleryStore.setLoadStatus(action.index, action.loadStatus);
      GalleryStore.emitChange();

      break;

    case ActionTypes.GALLERY_LIKE_SUCCESS:

      // pievieno jauno "Man patīk" skaitu
      GalleryStore.setLikes(action.index, action.count);
      GalleryStore.emitChange();

      break;

      // veiksmīgs ziņojums par bildi
    case ActionTypes.GALLERY_REPORT_SUCCESS:

      // nomaina statusu, ka ir noziņots par bildi
      GalleryStore.setReport(action.index);
      GalleryStore.emitChange();

      break;

      // komplimenta sūtīšana uz serveri
    case ActionTypes.GALLERY_COMPLIMENT_SEND:

      GalleryStore.setComplimentSending(true);
      GalleryStore.emitChange();

      break;

      // Kompliments veiksmīgi pievienots
    case ActionTypes.GALLERY_COMPLIMENT_SUCCESS:

      // Pievieno statusu, ka bildei ir kompliments
      GalleryStore.setCompliment(action.index);

      // Sūtīšana vairs nenotiek
      GalleryStore.setComplimentSending(false);
      GalleryStore.emitChange();

      break;

    default:
			// do nothing
  }
});

module.exports = GalleryStore;
